@if (icon) {
  <svg id="svgElement">
    <use
      attr.href="assets/icons/library-new.svg?v=236#{{ icon }}">
    </use>
  </svg>
}

@if (count) {
  <div class="icon__label">{{ count }}</div>
}

@if (name) {
  <wp-icon
    [attr.name]="name"
    [attr.size]="size"
    [attr.aria-label]="ariaLabel">
  </wp-icon>
}
